import axios from "axios";

const basePath =
    process.env.NODE_ENV === 'development'
        ? 'https://ekassa.id.md/'
        : '/';

// required in case of opening a project where the backend will be run locally
// const basePath = process.env.NODE_ENV === "development" ? "http://0.0.0.0:9032/" : "/";


// POST add new fiscal receipt
export function createNewReceipt(data, token, client) {
    let newConf = {
        url: `${basePath}api/acps/fiscal_receipt/${client}/`,
        method: 'post',
        headers: { Authorization: `Bearer ${token}` },
        data: data,
    }

    const response = axios(newConf)
    return response;
}


// GET Mev Id by receiptId 
export function getMevIdForByReceiptId(token, client, receiptId) {

    let newConf = {
        url: `${basePath}api/acps/fiscal_receipt/${client}/${receiptId}/mev`,
        method: 'get',
        headers: { Authorization: `Bearer ${token}` },
    }

    const response = axios(newConf)
    return response;
}


// POST add new service receipt
export function createNewServiceReceipt(data, token, client) {
    let newConf = {
        url: `${basePath}api/acps/service_receipt/${client}/`,
        method: 'post',
        headers: { Authorization: `Bearer ${token}` },
        data: data,
    }

    const response = axios(newConf)
    return response;
}

// POST resend notification
export function resendNotification(data, token) {
    let newConf = {
        url: `${basePath}api/resend_notification`,
        method: 'post',
        headers: { Authorization: `Bearer ${token}` },
        data: data
    }

    const response = axios(newConf)
    return response;
}